module.exports = __webpack_public_path__ + "iconaCOIN.svg?cb8a4db5d3d583d9c0fdd3483c3b474e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconaCOIN.svg
// module id = 797
// module chunks = 0